'use client';

import Link from 'next/link'
import { FaFacebookSquare, FaInstagram } from 'react-icons/fa'
import { useTranslation } from '@/hooks/useTranslation'
import LanguageSelector from '../i18n/LanguageSelector';
import CountrySelector from './CountrySelector';
import ThemeSelector from './ThemeSelector';
import { useRouter } from 'next/navigation';


const Footer = () => {
  const { t, lang } = useTranslation()

  const router = useRouter()

  return (
    <footer className="bg-[#f5f5f5] dark:bg-card pb-6 py-24 mt-auto mt-10 relative">
      <div className="flex flex-col items-center md:items-start px-6">
        {/* Language Selector - Top Right */}
        <div className="absolute top-8 flex md:hidden flex-row items-center justify-end gap-8">
          <ThemeSelector />
          <LanguageSelector />
          <CountrySelector />
        </div>

        <div className="hidden md:flex items-start flex-row justify-around w-full gap-8">
          {/* Atletas Column */}
          <div>
            <h3 className="font-bold mb-3">{t('footer.athletes.title')}</h3>
            <ul className="space-y-1 text-sm">
              <li><p className="text-muted-foreground cursor-pointer" onClick={() => router.push('/login')}>{t('footer.athletes.login')}</p></li>
            </ul>
          </div>

          {/* Organizador Column */}
          <div>
            <h3 className="font-bold mb-3">{t('footer.organizer.title')}</h3>
            <ul className="space-y-1 text-sm">
              <li><Link href="https://app.rockthesport.com/es/es/security/signin" target="_blank" className="text-muted-foreground">{t('footer.organizer.login')}</Link></li>
              <li><Link href="https://manager.rockthesport.com " target="_blank" className="text-muted-foreground">{t('footer.organizer.information')}</Link></li>
              <li><Link href="https://help.rockthesport.com/" target="_blank" className="text-muted-foreground">{t('footer.organizer.need_help')}</Link></li>
            </ul>
          </div>

          {/* RockTheSport Column */}
          <div>
            <h3 className="font-bold mb-3">{t('footer.rockthesport.title')}</h3>
            <ul className="space-y-1 text-sm">
              <li><Link href="https://manager.rockthesport.com/sobre-nosotros/" target="_blank" className="text-muted-foreground">{t('footer.rockthesport.about_us')}</Link></li>
            </ul>
          </div>

          {/* Condiciones legales Column */}
          <div className='relative'>
            {/* Language Selector - Top Right */}
            <div className="absolute right-0 -top-14 flex flex-row items-center justify-end gap-8">
              <ThemeSelector />
              <LanguageSelector />
              <CountrySelector />
            </div>

            <h3 className="font-bold mb-3">{t('footer.legal.title')}</h3>
            <ul className="space-y-1 text-sm">
              <li><Link href={`/${lang}/documentation/privacy-policy`} className="text-muted-foreground">{t('footer.legal.privacy_policy')}</Link></li>
              <li><Link href={`/${lang}/documentation/general-terms`} className="text-muted-foreground">{t('footer.legal.general_terms')}</Link></li>
              <li><Link href={`/${lang}/documentation/cookies-policy`} className="text-muted-foreground">{t('footer.legal.cookie_policy')}</Link></li>
              <li><Link href={`/${lang}/documentation/legal-notice`} className="text-muted-foreground">{t('footer.legal.legal_notice')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="flex md:hidden items-center flex-col">
          <div className='flex flex-col gap-8 justify-around'>
            {/* Atletas Column */}
            <div>
              <h3 className="font-bold mb-3">{t('footer.athletes.title')}</h3>
              <ul className="space-y-1 text-sm">
                <li><Link href="https://web.rockthesport.com/login" target="_blank" className="text-muted-foreground">{t('footer.athletes.login')}</Link></li>
              </ul>
            </div>

            {/* Organizador Column */}
            <div>
              <h3 className="font-bold mb-3">{t('footer.organizer.title')}</h3>
              <ul className="space-y-1 text-sm">
                <li><Link href="https://app.rockthesport.com/es/es/security/signin" target="_blank" className="text-muted-foreground">{t('footer.organizer.login')}</Link></li>
                <li><Link href="https://manager.rockthesport.com " target="_blank" className="text-muted-foreground">{t('footer.organizer.information')}</Link></li>
                <li><Link href="https://help.rockthesport.com/" target="_blank" className="text-muted-foreground">{t('footer.organizer.need_help')}</Link></li>
              </ul>
            </div>

            {/* RockTheSport Column */}
            <div>
              <h3 className="font-bold mb-3">{t('footer.rockthesport.title')}</h3>
              <ul className="space-y-1 text-sm">
                <li><Link href="https://manager.rockthesport.com/sobre-nosotros/" target="_blank" className="text-muted-foreground">{t('footer.rockthesport.about_us')}</Link></li>
              </ul>
            </div>

            {/* Condiciones legales Column */}
            <div>
              <h3 className="font-bold mb-3">{t('footer.legal.title')}</h3>
              <ul className="space-y-1 text-sm">
                <li><Link href={`/${lang}/documentation/privacy-policy`} target="_blank" className="text-muted-foreground">{t('footer.legal.privacy_policy')}</Link></li>
                <li><Link href={`/${lang}/documentation/general-terms`} className="text-muted-foreground">{t('footer.legal.general_terms')}</Link></li>
                <li><Link href={`/${lang}/documentation/cookies-policy`} target="_blank" className="text-muted-foreground">{t('footer.legal.cookie_policy')}</Link></li>
                <li><Link href={`/${lang}/documentation/legal-notice`} target="_blank" className="text-muted-foreground">{t('footer.legal.legal_notice')}</Link></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Social Media Icons */}
        <div className="my-10 flex justify-center w-full">
          <Link href="#" target="_blank" aria-label="Facebook" className="mr-2 text-muted-foreground inline-block">
            <FaFacebookSquare size={22} />
          </Link>
          <Link href="#" target="_blank" aria-label="Instagram" className="text-muted-foreground inline-block">
            <FaInstagram size={22} />
          </Link>
        </div>

        {/* Copyright */}
        <div className='border-t border-gray-200 dark:border-gray-800 pt-3 w-full'>
          <div className="text-center text-muted-foreground text-xs mt-4">
            {t('footer.copyright')}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 